import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { SzakokContext } from '../context/SzakokContext';
import { setActiveRole } from '../utils/authStorage';
import './ChooseRole.css';

const ChooseRole = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserContext);
  const { refetchData } = useContext(SzakokContext);

  const handleRoleChoice = (role) => {
    setLoading(true);
    setError('');

    try {
      setActiveRole(role, false);
      
      setUserData(prev => ({
        ...prev,
        role: role,
        requiresRoleSelection: false
      }));

      if (refetchData) {
        refetchData();
      }

      navigate('/');
    } catch (err) {
      console.error('Role choice error:', err);
      setError('Hiba történt a role kiválasztása során');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="choose-role-container">
      <div className="choose-role-card">
        <img 
          src="/sze_logo_full-ByPIlbSP.png" 
          alt="SZE Logo" 
          className="sze-logo"
        />
        <h2>Szerepkör választása</h2>
        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <div className="role-buttons">
          <button
            className="role-button admin-button"
            onClick={() => handleRoleChoice('admin')}
            disabled={loading}
          >
            <div className="role-content">
              <h3>Adminisztrátor</h3>
            </div>
          </button>

          <button
            className="role-button szakfelelos-button"
            onClick={() => handleRoleChoice('szakfelelos')}
            disabled={loading}
          >
            <div className="role-content">
              <h3>Szakfelelős</h3>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChooseRole;